module.exports = __webpack_public_path__ + "static/img/sdasd_tr.51be1fb6.jpg";